import BestandsaufnahmeModel from "@/models/ba/models/bestandsaufnahme.model";
import QueryString from "qs";
import { manageApiCall } from "../api-manager";

export const getSurveysByTemplate = async (templateId: string, projectId: number) => {

    // TODO: current endpoint is not acknowledging the populate parameter 
    const query = QueryString.stringify({
        filters: {
            vorlage_bestandsaufnahme: {
                uid: {
                    $contains: templateId
                }
            }
        },
        populate: {
            vorlage_bestandsaufnahme: {
                fields: ["id", "uid"]
            },
            immobilie: {
                fields: ["id", "externeObjektNr"]
            }
        }

    }, {
        encodeValuesOnly: true // prettify URL
    });

    const call = () => BestandsaufnahmeModel.api().get(`/bestandsaufnahmes?${query}&projectId=${projectId}`, { save: false });
    // TODO: add retry, error handling etc.
    const managedCall = manageApiCall(call);
    const response = await managedCall.makeRequest({});
    return response.response.data.results;
};